import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText'

/* 
const scrollText = document.getElementsByTagName("h1 strong");
const listItems = [SplitText(scrollText, words)];

gsap.registerPlugin(ScrollTrigger)

const tLine = gsap.timeLine();

// fade in
tl.to("h1 strong", {opacity: 1,stagger: 1}, )

ScrollTrigger.create({
animation : tLine,
trigger : '#list',
start : 'bottom center',
end : '+=500',
scrub : 0.1
}) */

gsap.utils.toArray("h2 strong").forEach((elem) => {
      const split = new SplitText(elem, { type: "words" });
      gsap.set(split.words, { opacity: 0.4 });

      gsap.to(split.words, {
        //stagger: { each: 0.08 },
        scrollTrigger: {
          trigger: elem,
          start: "top 65%",
          end: "top 20%",
          scrub: 0.5,
          markers: false
        },
        ease: "power1.out",
        opacity: 1,
      });
    });